/**
 * Notifications Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from '../../services/apiService';
import { queryKeys, STALE_TIMES } from '../../providers/QueryProvider';
import { NotificationList } from '../../types';

interface NotificationsListResponse {
  results: NotificationList[];
  count: number;
}

export function useNotificationsQuery(userId?: number) {
  return useQuery({
    queryKey: queryKeys.notifications(userId),
    queryFn: async (): Promise<NotificationsListResponse> => {
      return await notificationsApi.list();
    },
    staleTime: STALE_TIMES.NOTIFICATIONS,
  });
}

export function useMarkNotificationReadMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationId: number) => notificationsApi.markRead(notificationId),
    onSuccess: () => {
      // Invalidate notifications to refresh the list
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllNotificationsReadMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export default useNotificationsQuery;
